//#region Util Imports

import * as _ from 'underscore'

//#endregion

//#region DevExtreme Imports

import dxCheckBoxOptions from 'devextreme/ui/check_box'

//#endregion

import { Enums } from '../../models/common'
import { GetViewColumnOptions } from '../../models/core/op-view'
import { OpDepositoryElement, OpView, OpViewColumn } from '../../models/core'
import { OpEquipmentQuantity } from '../../models/custom'
import { OpEquipmentType } from '../../models/custom/op-equipment-type'

import { ColumnModel } from '../../modules/api/api.models'

import { LocalizationHelper, Dictionary, ConvertHelper } from '../../helpers'

import { GRID_SERVICE_NAME, GridService } from '../grid'
import { OrderService } from './order.service'
import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../user-session'

//#region Public Types

export const ORDER_CONFIRM_SERVICE_NAME = 'OrderConfirmService'
export const ORDER_CONFIRM_SERVICE_PROVIDER_NAME = 'OrderConfirmServiceProvider'

//#endregion

export class OrderConfirmService {

    //#region Consts

    public get ERROR_INFO_COLUMN_NAME(): string { return 'errorInfo' }

    //#endregion

    //#region Ctor

    constructor(
        private gridService: GridService,
        private userSessionService: UserSessionService
    ) { }

    //#endregion

    //#region Columns

    public getCheckBoxColumn(checkBoxOptionsFunc: (data: any) => dxCheckBoxOptions): ColumnModel {
        const column: ColumnModel = this.gridService.getToolbarColumn((gridData: any) => {
            return {
                items: [{
                    widget: 'dxCheckBox',
                    options: checkBoxOptionsFunc(gridData)
                }]
            }
        })

        column.idName = 'add'
        column.name = 'Add'
        column.caption = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Add)
        column.type = Enums.DataTypeClass.Text

        return column
    }

    public getErrorInfoColumn(): ColumnModel {
        const errorInfoColumn: ColumnModel = new ColumnModel()

        errorInfoColumn.idName = this.ERROR_INFO_COLUMN_NAME
        errorInfoColumn.name = this.ERROR_INFO_COLUMN_NAME
        errorInfoColumn.caption = ''
        errorInfoColumn.type = Enums.DataTypeClass.Text
        errorInfoColumn.hidden = true

        return errorInfoColumn
    }

    //#endregion

    public getContentList(quantity: OpEquipmentQuantity): OpDepositoryElement[] {

        const contentList: OpDepositoryElement[] = []
        const element: OpEquipmentQuantity = quantity

        if (element != null) {
            element.equipmentQuantity.forEach((equipmentType: OpEquipmentType) => {
                for (let i = 0; i < equipmentType.quantity; i++) {
                    const newDepoElement: OpDepositoryElement = new OpDepositoryElement(null)
                    newDepoElement.idArticle = equipmentType.article.idArticle
                    newDepoElement.startDate = new Date(Date.now())
                    newDepoElement.opState = Enums.OpChangeState.New
                    newDepoElement.idDepositoryElement = element.referenceValue.idDepositoryElement ? element.referenceValue.idDepositoryElement : 0
                    newDepoElement.idDeviceStateType = 2
                    newDepoElement.idDeviceTypeClass = 2
                    contentList.push(newDepoElement)
                }
            })
        }
        return contentList
    }

    // #region View

    public getColumnNamesForDataParser(): JQueryPromise<Dictionary<string>> {
        const dataTypes: Enums.DataType[] = [Enums.DataType.HELPER_NAME, Enums.DataType.HELPER_ID_PACKAGE]
        const dict: Dictionary<string> = new Dictionary<string>(null)

        return this.userSessionService
            .getDataProvider()
            .View
            .getActiveView(Enums.ReferenceType.IdPackage)
            .then((view: OpView) => {
                dataTypes.forEach((dataType: Enums.DataType) => {
                    let value: string = ''
                    const viewColumn: OpViewColumn = view.getViewColumn(new GetViewColumnOptions(dataType))
                    const key: number = ConvertHelper.parseEnum<number>(Enums.DataType, dataType)

                    if (viewColumn != null && _.size(viewColumn.name) > 0) {
                        value = viewColumn.name.toLowerCase()
                    } else {
                        console.log(OrderService.LOG_PREFIX + ' not found column name')
                    }

                    dict.add(key, value)
                })
                return dict
            })
    }

    // #endregion
}

export class OrderConfirmServiceProvider implements ng.IServiceProvider {

    //#region IServiceProvider Implementation 

    public $get = [
        GRID_SERVICE_NAME,
        USER_SESSION_SERVICE_NAME,
        function (
            gridService: GridService,
            userSerssionService: UserSessionService
        ) {
            return new OrderConfirmService(gridService, userSerssionService);
        }]

    //#endregion
} 